import { AiCreateArtworkModel } from '~/graphqls/types'

interface Product {
  model?: AiCreateArtworkModel | null
  modelTheme?: string | null
  styleModelOption?: {
    name?: string | null
  } | null
}

export const useShowModel = () => {
  const getSubModelName = (product?: Product | null) => {
    if (product?.model === AiCreateArtworkModel.STYLE) {
      if ((product?.styleModelOption?.name || '')?.length > 1) {
        return ` (${product?.styleModelOption?.name})`
      } else {
        return ''
      }
    }

    if ((product?.modelTheme || '')?.length > 1) {
      return ` (${product?.modelTheme})`
    } else {
      return ''
    }
  }
  return {
    getSubModelName,
  }
}
